import type { ReportData } from 'teacher-ui-client/components/reporting/writing-legends/quizzes-completed/history/report-loader'
import Component from '@glimmer/component'
import type { SeriesBarOptions, XAxisOptions, YAxisOptions } from 'highcharts'
import { colors } from '@colors'
import { SeriesBar } from 'teacher-ui-client/components/giraffe/primitives/series-bar'
import { array } from '@ember/helper'
import { t } from 'ember-intl'

interface Signature {
  Element: HTMLDivElement
  Args: {
    studentsReportData: ReportData['students']
  }
}

export class HistoryChart extends Component<Signature> {
  readonly plotBackgroundColor = colors.dustyBlack50

  get yAxis(): YAxisOptions {
    return {
      opposite: true,
      labels: {
        format: '{value}%',
      },
      max: 100,
      tickInterval: 25,
      title: {
        text: undefined,
      },
      showFirstLabel: false,
      visible: true,
    }
  }

  get xAxis(): XAxisOptions {
    return {
      labels: {
        enabled: false,
      },
      categories: [],
      lineWidth: 0,
      gridLineWidth: 2,
      gridLineColor: colors.dustyBlack100,
      tickWidth: 0,
    }
  }

  get quizScores() {
    return this.args.studentsReportData.map((student) => student.avg_score)
  }

  get seriesBarData(): SeriesBarOptions[] {
    return [{ data: this.quizScores, color: colors.oceanyBlue325, type: 'bar' }]
  }

  <template>
    <div class="relative" ...attributes>
      <div class="absolute inset-0">
        <SeriesBar
          @data={{this.seriesBarData}}
          @groupPadding={{0.02}}
          @title={{t "reporting.chartTitles.quizScoresHistory"}}
          @plotBackgroundColor={{this.plotBackgroundColor}}
          @yAxis={{this.yAxis}}
          @xAxis={{this.xAxis}}
          @chartMargin={{array 81 20 0 6}}
          @chartSpacing={{array 10 10 10 10}}
        />
      </div>
    </div>
  </template>
}
